import React from 'react';
import { TileToolbar } from 'widgets/tiles/components/tile/TileToolbar';
import useWidgetStream from 'widgets/streaming/useWidgetStream';
import { WidgetTile } from 'widgets/tiles/components/tile/WidgetTile';
import { usePlCapsuleConfigSlice } from '../store/config/configslice';
import { PlCapsuleContent } from './PlCapsuleContent';
import PlCapsuleSettings, {
    PlCapsuleSettingsText,
} from './settings/PlCapsuleSettings';
import PlCapsuleChartHelp from './chart/PlCapsuleChartHelp';

import { useWidgetContext } from 'widgets/WidgetContext';

import './PlCapsule.scss';
import { useSelectParentCapsuleContainerConfiguredSymbol } from 'widgets/tiles/store/hooks';
import { useFillsGraphPortfolioData } from 'widgets/fillsGraph/fillsGraphPortfolioData';
import InfoBox from 'utils/components/InfoBox/InfoBox';
import { usePlCapsuleData } from 'widgets/plCapsule/hooks';
import { PnlBenchmark } from 'utils/PnL';

export function PlCapsule() {
    const { config, dispatchConfigChanged } = usePlCapsuleConfigSlice();

    useWidgetStream();

    const { widgetKey } = useWidgetContext();

    const parentCapsuleBoundSymbol =
        useSelectParentCapsuleContainerConfiguredSymbol();
    const portfolioData = useFillsGraphPortfolioData();

    const { pnlChartBenchmark } = config;

    const isPinned = !!parentCapsuleBoundSymbol;
    const hasFullOrderData = portfolioData?.hasFullOrderData;

    const data = usePlCapsuleData();

    const selectionMessage = isPinned
        ? 'Not available for pinned Capsule Containers'
        : !hasFullOrderData
        ? 'Select an order'
        : undefined;

    const subtitle = `by ${
        pnlChartBenchmark === PnlBenchmark.Arrival ||
        pnlChartBenchmark === PnlBenchmark.IndividualOrderArrival
            ? 'Arr'
            : pnlChartBenchmark === PnlBenchmark.Vwap
            ? 'xVWAP'
            : pnlChartBenchmark === PnlBenchmark.Last
            ? 'Last'
            : ''
    }`;

    return (
        <WidgetTile className="PlCapsule">
            <TileToolbar
                title="P&L"
                subtitle={subtitle}
                settingsBody={<PlCapsuleSettings />}
                settingsHeader={PlCapsuleSettingsText}
                preceedingItems={<PlCapsuleChartHelp />}
                settingsClassName={'PlCapsuleSettingsModal'}
            />

            <div className="capsule-body">
                {selectionMessage && <InfoBox info={selectionMessage} />}
                {!selectionMessage && (
                    <PlCapsuleContent
                        data={data}
                        config={config}
                        dispatchConfigChanged={dispatchConfigChanged}
                        capsuleKey={widgetKey}
                    />
                )}
            </div>
        </WidgetTile>
    );
}
